import { Button, DialogFooter } from '@/components/ui';
import { useFormContext } from 'react-hook-form';
import { VerificationStateEnum } from '@/enums';
import { broadcastService } from '@/services';
import { useState } from 'react';
import { TFormData } from '.';

interface IState {
  isLoading: boolean;
}

type TProps = {
  onSubmit: (state: VerificationStateEnum, comment: string) => Promise<void>;
};

const VARIABLES = {
  initState: {
    isLoading: false
  } as IState
};

const FormCommentReviewFooter = ({ onSubmit }: TProps) => {

  const { handleSubmit, setValue, formState: { isValid, isSubmitting } } = useFormContext<TFormData>();
  const [state, setState] = useState<IState>(VARIABLES.initState);

  const handleOnClickBtnCancel = () =>
    broadcastService.modal.hide();

  const handleOnClickBtnSave = () =>
    handleSubmit(
      async data => {
        try {
          setState(l => ({ ...l, isLoading: true }));
          // Call submit mehtod
          await
            onSubmit(
              data.state,
              data.comment
            )
              .catch(error => { throw new Error(error?.internalMessage); });
          // Close modal
          broadcastService.modal.hide();
        } catch (error) {
          setValue('errorMessage', (error as Error)?.message);
        } finally {
          setState(l => ({ ...l, isLoading: false }));
        }
      }
    )();

  return (
    <DialogFooter>
      <div className='w-full flex justify-between'>
        <Button
          onClick={handleOnClickBtnCancel}
          disabled={isSubmitting || state.isLoading}
          variant='secondary'
          type='button'
          size={'sm'}>
          Annuler
        </Button>
        <Button
          onClick={handleOnClickBtnSave}
          disabled={!isValid || isSubmitting || state.isLoading}
          type='button'
          size={'sm'}>
          Commenter
        </Button>
      </div>
    </DialogFooter>
  );

};

export default FormCommentReviewFooter;
